<template>
  <div>
    <el-card v-auth="'/order/pageList'">
      <!-- <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth"> -->
      <el-row :gutter="20" class="searchRow">
        <el-col :sm="24" :md="12" :lg="4">
          <el-cascader style="width: 100%" clearable v-model="campusIdList" :show-all-levels="false" :props="campusTreeProps" placeholder="请选择学员所属校区" :options="campusList" collapse-tags @change="campusIdListChange"></el-cascader>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-cascader style="width: 100%" clearable collapse-tags v-model="courseIds" :show-all-levels="false" :props="subjectTreeProp" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectChangeTop"></el-cascader>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-input v-model="searchForm.agentUserName" placeholder="请输入代理人姓名/号码" auto-complete="off"></el-input>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-input v-model="searchForm.orderName" placeholder="请输入商品名" auto-complete="off"></el-input>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-input v-model="searchForm.studentName" placeholder="请输入学生姓名/号码" auto-complete="off"></el-input>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-input v-model="searchForm.number" placeholder="请输入订单编号" auto-complete="off"></el-input>
        </el-col>
        <el-col :sm="24" :md="24" :lg="8">
          <el-date-picker style="width: 100%" v-model="createTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="下单开始日期" end-placeholder="下单结束日期" :picker-options="pickerOptions" @change="createTimeChange"></el-date-picker>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-select v-model="searchForm.whetherToShip" style="width: 100%" placeholder="请选择是否发货" v-if="showWhetherToShip">
            <el-option label="全部" value></el-option>
            <el-option label="已发货" value="1"></el-option>
            <el-option label="未发货" value="-1"></el-option>
          </el-select>
        </el-col>
        <el-col :sm="8" :md="8" :lg="8" style="text-align: right; float: right">
          <el-button type="primary" style @click="selectPageList()" icon="el-icon-search" v-auth="'/order/pageList'">查询</el-button>
          <el-button type="primary" style @click="exportExcel()" icon="el-icon-search" v-if="hasPermission" v-auth="'/order/exportExcel'">导出</el-button>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="16" style="float: right;">
            <div style="float: right;">
              <a @click="reset" style="line-height:40px;margin-left:-10px" class="mainColor ml">重置</a>
              <el-button type="primary" style @click="selectPageList" icon="el-icon-search">查询</el-button>
            </div>

          </el-col>
      </el-row>-->
      <el-row :gutter="20"></el-row>
      <!-- </el-form> -->
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24" style="margin-bottom: 10px">
        <el-col :span="12" :key="orderListStats.count">
          <div style="
              line-height: 40px;
              color: #333;
              font-size: 14px;
              display: inline;
              margin-right: 20px;
            ">
            订单数量：
            <span style="font-size: 14px; font-weight: bold">{{ orderListStats.count }}单</span>
          </div>
          <div style="
              line-height: 40px;
              color: #333;
              font-size: 14px;
              display: inline;
            ">
            金额合计：
            <span style="font-size: 14px; font-weight: bold">{{ orderListStats.amount }}元</span>
          </div>
        </el-col>
        <el-col :span="12" v-if="checkCampusAgentTrue == true">
          <el-button v-if="admin === 1" style="float: right" type="primary" @click="exportExcel()" v-auth="'/order/exportExcel'">导出订单</el-button>
          <el-button style="float: right; margin-right: 10px" @click="$router.push({ path: '/addOrders' })" type="primary" icon="el-icon-plus" v-auth="'/order/addOrders'">订单
          </el-button>
        </el-col>
      </el-row>
      <el-table :data="page.rows" tooltip-effect="dark" style="margin-top: 0px; width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-table-column show-overflow-tooltip prop="number" width="136" label="单号">
          <template slot-scope="row">
            <span class="mainColor">{{ row.row.number }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="student.name" label="姓名"></el-table-column>
        <el-table-column show-overflow-tooltip prop="student.mobile" label="手机号"></el-table-column>
        <el-table-column show-overflow-tooltip width="150" prop="createTime" label="下单时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="totalAmount" label="总价（元）"></el-table-column>
        <el-table-column show-overflow-tooltip prop="sourceType" label="订单来源"></el-table-column>
        <el-table-column show-overflow-tooltip prop="agentUserName" label="操作人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderName" label="商品名"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderState" label="" :render-header="renderSpecNameHeader" align="center" width="90">
          <template slot-scope="row">
            <span class="paid style1" v-if="row.row.orderState == '已付款'">{{
                row.row.orderState
            }}</span>
            <span class="paid style2" v-if="row.row.orderState == '待付款'">{{
                row.row.orderState
            }}</span>
            <span class="paid style3" v-if="row.row.orderState == '已取消'">{{
                row.row.orderState
            }}</span>
            <span class="paid style3" v-if="row.row.orderState == '已退款'">{{
                row.row.orderState
            }}</span>
            <span class="paid style3" v-if="row.row.orderState == '申请中'">{{
                row.row.orderState
            }}</span>
            <span class="paid style3" v-if="row.row.orderState == '已驳回'">{{
                row.row.orderState
            }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column show-overflow-tooltip prop="paidState" label="付款方式">
          <template
            slot-scope="row"
          >{{row.row.paidState == 1 ? row.row.orderPaymentList[0].channel : "未支付"}}</template>
        </el-table-column>-->

        <!-- <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="address" label="收货地址"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
        <el-table-column show-overflow-tooltip label="发货" align="center" width="80px" v-if="showWhetherToShip">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.whetherToShip" :active-value="1" :inactive-value="-1" @change="updateSwitching(scope.row)" class="switchStyle" active-text="是" inactive-text="否"></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="250" align="center">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-between">
              <!-- <span @click="showPayDetail(scope.row)">查看</span> -->
              <span class="operation-style" style="margin-left: 8px" @click="addRemark(scope.row)" v-auth="'/order/addRemark'">备注</span>
              <span class="operation-style" style="margin-left: 8px" @click="goDetail(scope.row)" v-auth="'/order/goDetail'">查看</span>
              <span v-if="scope.row.orderState == '已付款' && scope.row.delay === 1" class="operation-style" style="margin-left: 8px" @click="addTime(scope.row)" v-auth="'/order/addTime'">延期</span>
              <!-- &&scope.row.sourceType=='代理下单' -->
              <span v-if="
                (scope.row.orderState == '已付款' ||
                  scope.row.orderState == '已驳回') &&
                scope.row.orderType != '1' &&
                scope.row.type != '充值订单'
              " style="margin-left: 8px" class="operation-style" @click="chargebackTrue(scope.row)" v-auth="'/order/chargebackTrue'">退单</span>
              <span v-if="
                (scope.row.orderState == '已付款' ||
                  scope.row.orderState == '已驳回') &&
                scope.row.orderType != '1' &&
                scope.row.type != '充值订单'
              " style="margin-left: 8px" class="operation-style" @click="chargebackPart(scope.row)" v-auth="'/order/partRefund'">部分退款</span>
              <span class="operation-style" style="margin-left: 8px" @click="addAddressDialog(scope.row)" v-auth="'/order/addAddressDialog'">收货地址</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>

    <el-dialog title="退单" :visible.sync="chargebackVisible" width="400px" left :close-on-click-modal="false">
      <el-form :model="chargebackForm" label-width="80px" :rules="chargebackFormRules" ref="chargebackForm">
        <el-form-item label="退款理由" prop="refundReason">
          <el-input v-model="chargebackForm.refundReason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="chargebackVisible = false">取 消</el-button>
        <el-button type="primary" @click="chargeback()">确 定</el-button>
      </div>
    </el-dialog>

    <!--部分退款-->
    <el-dialog title="部分退款" :visible.sync="chargebackPartVisible" width="400px" left :close-on-click-modal="false">
      <el-form :model="chargebackPartForm" label-width="80px" :rules="chargebackPartRules" ref="chargebackPartForm">
        <el-form-item label="退款原因" prop="refundPartReason">
          <el-input v-model="chargebackPartForm.refundPartReason"></el-input>
        </el-form-item>
        <el-form-item label="教材金额" prop="refundPartMoney">
          <el-input v-model="chargebackPartForm.refundPartMoney"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="chargebackPartVisible = false">取 消</el-button>
        <el-button type="primary" @click="backPartSure()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="收货地址" :visible.sync="addAddressDialogVisible" width="400px" left :close-on-click-modal="false">
      <el-form :model="addAddressForm" label-width="80px" :rules="addAddressFormRules" ref="addAddressForm">
        <el-form-item label="收货地址" prop="address">
          <el-input v-model="addAddressForm.address"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addAddressDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAddress()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="订单信息" :visible.sync="payFormVisible" width="800px" left>
      <el-row :gutter="20">
        <el-col :span="24">
          <span style="font-size: 14px; font-weight: 500; color: #000">订单信息</span>
          <span style="margin-left: 20px" class="paid style1" v-if="payForm.orderState == '已付款'">{{ payForm.orderState }}</span>
          <span style="margin-left: 20px" class="paid style2" v-if="payForm.orderState == '待付款'">{{ payForm.orderState }}</span>
          <span style="margin-left: 20px" class="paid style3" v-if="payForm.orderState == '已取消'">{{ payForm.orderState }}</span>
          <span style="margin-left: 20px" class="paid style3" v-if="payForm.orderState == '已退款'">{{ payForm.orderState }}</span>
          <span style="margin-left: 20px" class="paid style3" v-if="payForm.orderState == '已驳回'">{{ payForm.orderState }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="8">
          <span>订单编号：{{ payForm.number ? payForm.number : "" }}</span>
        </el-col>
        <el-col :span="8">
          <span>学员姓名：{{ payForm.student ? payForm.student.name : '' }}</span>
        </el-col>
        <el-col :span="8">
          <span>学员电话：{{ payForm.student ? payForm.student.mobile : '' }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 20px">
        <!-- <el-col :span="8">
          <span>是否开票：{{payForm.agentId ? payForm.agentId : ''}}</span>
        </el-col>-->
        <el-col :span="8">
          <span>订单来源：{{ payForm.sourceType ? payForm.sourceType : '' }}</span>
        </el-col>
        <el-col :span="8">
          <span>支付IP：{{ payForm.ip ? payForm.ip : "" }}</span>
        </el-col>
        <el-col :span="8">
          <span>下单时间：{{ payForm.createTime ? payForm.createTime : '' }}</span>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" style="margin-top:20px;">
        <el-col :span="8">
          <span>下单时间：{{payForm.createTime ? payForm.createTime : ''}}</span>
        </el-col>
      </el-row>-->
      <el-table :data="payForm.orderItemList" tooltip-effect="dark" style="margin-top: 21px; width: 100%" border>
        <el-table-column prop="goodsName" label="商品名称"></el-table-column>
        <el-table-column prop="goodsPrice" label="单价"></el-table-column>
        <el-table-column prop="goodsQuantity" label="数量"></el-table-column>
        <el-table-column prop="goodsTotalAmount" label="总价"></el-table-column>
      </el-table>
      <div style="margin-top: 20px; font-size: 14px; font-weight: 500; color: #000">
        订单实付金额
      </div>
      <el-table :data="payForm.orderPaymentList" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border>
        <el-table-column prop="channel" label="支付类型"></el-table-column>
        <el-table-column prop="paymentTime" label="时间"></el-table-column>
        <el-table-column prop="tradeAmount" label="实付金额(元)"></el-table-column>
        <el-table-column prop="tradePaymentAccount" label="付款账户"></el-table-column>
        <el-table-column prop="tradeState" label="状态"></el-table-column>
      </el-table>
      <!-- <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="payFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrderInfo">确 定</el-button>
      </div>-->
    </el-dialog>
    <el-dialog title="备注" :visible.sync="remarkModal" width="400px" left :close-on-click-modal="false">
      <el-form :model="remarkForm" label-width="80px" :rules="remarkFormRules" ref="remarkFormS">
        <el-form-item label="备注" prop="address">
          <el-input v-model="remarkForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="remarkModal = false">取 消</el-button>
        <el-button type="primary" @click="okRemark()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectHeader from "./SelectHeader";

export default {
  data() {
    return {
      // 管理员删除
      showWhetherToShip: "",
      admin: 0,
      loginRole: "",
      addRemarkData: {},
      remarkModal: false,
      permissions: ["18921166406", "17706173358", "18118895168", "13347917817"],
      hasPermission: false,
      checkCampusAgentTrue: false,
      paidTime: [],
      createTime: [],
      orderStateForm: [],
      orderSourceForm: [],
      orderListStats: {},
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      payFormVisible: false,
      chargebackVisible: false,
      addAddressDialogVisible: false,
      chargebackPartVisible: false,
      totalAmount: "",
      chargebackForm: {
        refundReason: "",
      },
      chargebackPartForm: {
        refundPartReason: "",
        refundPartMoney: "",
      },
      addAddressForm: {
        address: "",
      },
      remarkForm: {
        remark: "",
      },
      searchForm: {
        orderState: "",
        sourceType: "",
        studentName: "",
        agentUserName: "",
        number: "",
        campusIdList: [],
        // notType: "充值订单",
      },
      payForm: {
        student: {},
        goodsInfoList: {},
      },
      chargebackFormRules: {
        refundReason: [
          {
            required: true,
            message: "请输入退款理由",
            trigger: "blur",
          },
        ],
      },
      chargebackPartRules: {
        refundPartReason: [
          {
            required: true,
            message: "请输入退款理由",
            trigger: "blur",
          },
        ],
        refundPartMoney: [
          {
            required: true,
            message: "请输入教材金额",
            trigger: "blur",
          },
        ],
      },
      remarkFormRules: {
        address: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur",
          },
        ],
      },
      addAddressFormRules: {
        address: [
          {
            required: true,
            message: "请输入收货地址",
            trigger: "blur",
          },
        ],
      },
      formLabelWidth: "80px",
      selection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/orderInfo/upload`,
      fileList: [],
      loading: true,
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      campusList: [],
      campusIdList: "",
      subjectTreeList: [], //科目
      courseIds: [],
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
    };
  },
  methods: {
    updateSwitching(row) {
      console.log(row.whetherToShip);
      if (row.whetherToShip == "1") {
        this.$confirm("是否发货", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.getOn(row);
            this.selectPageList();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
            this.selectPageList();
          });
      } else {
        this.$confirm("是否取消发货", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.getOff(row);
            this.selectPageList();
          })
          .catch(() => {
            this.selectPageList();
          });
      }
    },
    getOn(row) {
      this.api.orderInfo
        .updateWhetherToShip({ id: row.id, whetherToShip: row.whetherToShip })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: "发货成功!",
            });
          }
        });
    },
    getOff(row) {
      this.api.orderInfo
        .updateWhetherToShip({ id: row.id, whetherToShip: row.whetherToShip })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: "取消发货!",
            });
          }
        });
    },
    // 延期
    addTime(row) {
      this.$prompt("请输入延期天数", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d{1,3}$/,
        inputErrorMessage: "延期天数只能1-3位",
      })
        .then(({ value }) => {
          let obj = {
            studentId: row.student.id,
            goodsValidDay: value,
            id: row.id,
          };
          this.api.orderInfo.updateStudentGoodsByDay(obj).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    addRemark(row) {
      this.remarkModal = true;
      this.addRemarkData = row;
    },
    okRemark() {
      this.$refs.remarkFormS.validate((valid) => {
        let obj = {
          id: this.addRemarkData.id,
          remark: this.remarkForm.remark,
        };
        this.api.orderInfo.addNewRemark(obj).then((result) => {
          if (result.success) {
            this.remarkModal = false;
            this.remarkForm.remark = "";
            this.pageList();
          } else {
            this.remarkModal = false;
            this.remarkForm.remark = "";
            this.$message.error(result.message);
          }
        });
      });
    },
    getSubjectTreeList() {
      this.api.campus
        .getPermissionSubjectTree()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    subjectChangeTop() {
      if (this.courseIds) {
        this.searchForm.subjectIds = [];
        this.courseIds.forEach((item) => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    campusIdChange(item) {
      let length = item.length;
      let index = length;
      this.searchForm.campusIdList = item[index - 1];
    },
    campusIdListChange() {
      this.searchForm.campusIdList = [];
      this.campusIdList.forEach((e) => this.searchForm.campusIdList.push(e[2]));
    },
    getCampusList() {
      this.api.campus
        .getPermissionCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkCampusAgent() {
      this.api.orderInfo.checkCampusAgent().then((result) => {
        if (result.success) {
          this.checkCampusAgentTrue = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    renderSpecNameHeader(createElement, { column, $index }) {
      let self = this;

      //该列的绑定数据
      console.log(column);
      //列号
      console.log($index);

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "order",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName",
              },
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            },
          }),
        ]
      );
    },
    //选择框回调
    selectChange(val) {
      this.searchForm.orderState = val;
      this.pageList(val);
      //写点啥吧
    },
    paidTimeChange() {
      if (this.paidTime) {
        this.searchForm.paidTimeBegin = this.paidTime[0];
        this.searchForm.paidTimeEnd = this.paidTime[1];
      } else {
        this.searchForm.paidTimeBegin = "";
        this.searchForm.paidTimeEnd = "";
      }
    },
    createTimeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    showPayDetail(row) {
      this.payForm = row;
      this.payFormVisible = true;
    },
    goDetail(row) {
      this.$router.push({
        path: "/detials",
        query: {
          id: row.id,
        },
      });
    },
    getOrderInfo(row) {
      // this.api.orderInfo
      //   .getOrderInfo({
      //     id: this.selection
      //   })
      //   .then(result => {
      //     this.editForm = result.data;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },

    selectPageList() {
      // if (typeof val == "string") {
      //   this.searchForm.orderState = val;
      // } else {
      //   this.searchForm.orderState = "";
      // }
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = 1;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.orderInfo.getOrderListStats(this.searchForm).then((result) => {
        this.orderListStats = result.data;
      });
      this.api.orderInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportExcel() {
      this.loading = true;
      this.api.orderInfo
        .exportExcel(this.searchForm)
        .then((result) => {
          if (result.success) {
            if (result.data.indexOf("https") == -1) {
              result.data = result.data.replace("http", "https");
            }
            location.href = result.data;
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList(val) {
      // if (typeof val == "string") {
      //   this.searchForm.orderState = val;
      // } else {
      //   this.searchForm.orderState = "";
      // }
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.orderInfo.getOrderListStats(this.searchForm).then((result) => {
        this.orderListStats = result.data;
      });
      this.api.orderInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
          this.showWhetherToShip = result.data.records[0].showWhetherToShip;
          console.log(this.showWhetherToShip, "this.showWhetherToShip");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addOrderInfo() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.api.orderInfo
            .addOrderInfo(this.addForm)
            .then((result) => {
              this.addFormVisible = false;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateOrderInfo() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.orderInfo
            .updateOrderInfo(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    //点击退单
    chargebackTrue(row) {
      this.chargebackVisible = true;
      this.orderInfoId = row.id;
    },
    //部分退单
    chargebackPart(row) {
      this.totalAmount = row.totalAmount;
      this.chargebackPartVisible = true;
      this.orderInfoId = row.id;
    },
    //添加收货地址
    addAddressDialog(row) {
      this.addAddressDialogVisible = true;
      this.orderInfoId = row.id;
      this.addAddressForm.address = row.address;
    },
    //退单
    chargeback() {
      if (this.chargebackBlock) {
        return false;
      }
      this.$refs.chargebackForm.validate((valid) => {
        let obj = {
          refundPeople: JSON.parse(localStorage.getItem("user")).openId,
          id: this.orderInfoId,
          refundReason: this.chargebackForm.refundReason,
        };
        this.chargebackBlock = true;
        setTimeout(() => {
          this.chargebackBlock = false;
        }, 2000);
        this.api.orderInfo.refundOrder(obj).then((result) => {
          if (result.success) {
            this.chargebackBlock = false;
            this.chargebackVisible = false;
            this.chargebackForm.refundReason = "";
            this.pageList();
          } else {
            this.chargebackBlock = false;
            this.chargebackVisible = false;
            this.chargebackForm.refundReason = "";
            this.$message.error(result.message);
          }
        });
      });
    },
    //部分退单
    backPartSure() {
      if (this.chargebackBlock) {
        return false;
      }
      if (this.chargebackPartForm.refundPartMoney > this.totalAmount) {
        this.$message.error("退款金额不能大于订单总金额");
      } else {
        this.$refs.chargebackPartForm.validate((valid) => {
          if (valid) {
            let obj = {
              refundPeople: JSON.parse(localStorage.getItem("user")).openId,
              id: this.orderInfoId,
              refundReason: this.chargebackPartForm.refundPartReason,
              partType: 1,
              textBookPrice: this.chargebackPartForm.refundPartMoney,
            };
            this.chargebackBlock = true;
            setTimeout(() => {
              this.chargebackBlock = false;
            }, 2000);
            this.api.orderInfo.partRefundOrder(obj).then((result) => {
              this.chargebackBlock = false;
              this.chargebackPartVisible = false;
              this.chargebackPartForm.refundPartReason = "";
              this.chargebackPartForm.refundPartMoney = "";
              if (result.success) {
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            });
          }
        });
      }
    },
    addAddress() {
      this.$refs.addAddressForm.validate((valid) => {
        let obj = {
          id: this.orderInfoId,
          address: this.addAddressForm.address,
        };
        this.api.orderInfo.addAddress(obj).then((result) => {
          if (result.success) {
            this.addAddressDialogVisible = false;
            this.addAddressForm.address = "";
            this.pageList();
          } else {
            this.addAddressDialogVisible = false;
            this.addAddressForm.address = "";
            this.$message.error(result.message);
          }
        });
      });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.createTime = [];
      this.paidTime = [];
      this.searchForm.createTimeBegin = "";
      this.searchForm.paidTimeBegin = "";
      this.searchForm.createTimeEnd = "";
      this.searchForm.studentName = "";
      this.searchForm.agentUserName = "";
      this.searchForm.paidTimeEnd = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    getOrderSourceType() {
      this.api.orderInfo.getOrderSourceType().then((result) => {
        this.orderSourceForm = result.data;
      });
    },
    getOrderState() {
      this.api.orderInfo.getOrderState().then((result) => {
        this.orderStateForm = result.data;
      });
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      this.hasPermission = this.permissions.indexOf(user.account) > -1;
    },
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getOrderInfo();
      }
    },
  },
  mounted() {
    this.admin = this.reqData.admin;
    // console.log('reqData=',this.reqData);
    // console.log(this.admin);
    this.api.orderInfo.getOrderListRole().then((result) => {
      this.loginRole = result.data;
    });
    // this.adminOn = JSON.parse(localStorage.getItem("user")).admin;
    // console.log(this.adminOn, 789789789);
    this.checkCampusAgent();
    this.pageList();
    this.getOrderState();
    this.getOrderSourceType();
    this.getCampusList();
    this.getSubjectTreeList();
    this.getPermissionList();
  },
};
</script>
<style scoped>
.el-select {
  width: 100% !important;
}

.paid {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}

.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}

.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}

.style4 {
  background: rgb(255, 100, 107);
  border: solid 1px rgb(255, 100, 107);
}

.searchRow .el-col {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderInfo/index.vue